import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { severityClass } from "../lib/utils";
import { AlertTriangle, Sparkles, Check, Ban } from "lucide-react";
import AdviserDrawer from "../components/AdviserDrawer";

export default function Anomalies() {
  const [rows, setRows] = useState([]);
  const [statusF, setStatusF] = useState("open");
  const [busy, setBusy] = useState(false);
  const [adviser, setAdviser] = useState({ open: false, anomalyId: null });

  const load = async () => {
    const r = await api.get("/anomalies", { params: statusF ? { status_f: statusF } : {} });
    setRows(r.data);
  };
  useEffect(() => { load(); }, [statusF]);

  const act = async (anom, action) => {
    setBusy(true);
    try {
      await api.post(`/anomalies/${anom.id}/action`, { action });
      await load();
    } finally { setBusy(false); }
  };

  return (
    <div className="p-6 space-y-4" data-testid="anomalies-root">
      <div>
        <div className="section-label">Data Quality</div>
        <h1 className="text-2xl font-bold tracking-tight mt-1">Anomaly Workbench</h1>
        <p className="text-sm text-ink-soft">Triage, explain and resolve KPI data anomalies. AI ESG Adviser can investigate root causes.</p>
      </div>

      <div className="flex items-center gap-2">
        {["open", "resolved", "overridden", ""].map(s => (
          <button
            key={s || "all"}
            data-testid={`anom-filter-${s || 'all'}`}
            onClick={() => setStatusF(s)}
            className={"pill " + (statusF === s ? "pill-success" : "")}
          >{s ? s : "all"}</button>
        ))}
      </div>

      <div className="card overflow-hidden">
        <table className="dense">
          <thead>
            <tr>
              <th>Severity</th>
              <th>KPI</th>
              <th>Type</th>
              <th>Period</th>
              <th className="text-right">Δ%</th>
              <th>Recommended action</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map(a => (
              <tr key={a.id} data-testid={`anom-row-${a.id}`}>
                <td><span className={severityClass(a.severity)}>{a.severity}</span></td>
                <td>
                  <Link className="font-medium hover:text-brand" to={`/kpi/${a.kpi_id}`}>{a.kpi?.name || a.kpi_id}</Link>
                  <div className="text-[11px] text-ink-soft">{a.kpi?.material_issue}</div>
                </td>
                <td className="capitalize">{a.type.replaceAll("_", " ")}</td>
                <td className="font-mono text-xs">{a.period}</td>
                <td className="num">{a.delta_pct ? `${a.delta_pct > 0 ? "+":""}${a.delta_pct.toFixed(1)}%` : "—"}</td>
                <td className="text-ink-soft text-xs max-w-md">{a.recommended_action}</td>
                <td>
                  <span className={
                    a.status === "open" ? "pill pill-warn" :
                    a.status === "resolved" ? "pill pill-success" :
                    "pill"
                  }>{a.status}</span>
                </td>
                <td className="text-right whitespace-nowrap">
                  <button
                    data-testid={`anom-explain-${a.id}`}
                    onClick={()=>setAdviser({open:true, anomalyId: a.id})}
                    className="btn btn-ghost"><Sparkles size={12}/> Explain</button>
                  {a.status === "open" && (
                    <>
                      <button
                        data-testid={`anom-approve-${a.id}`}
                        disabled={busy} onClick={()=>act(a, "approve")}
                        className="btn btn-secondary"><Check size={12}/> Resolve</button>
                      <button
                        data-testid={`anom-override-${a.id}`}
                        disabled={busy} onClick={()=>act(a, "override")}
                        className="btn btn-ghost"><Ban size={12}/> Override</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr><td colSpan={8} className="text-center text-ink-soft py-6"><AlertTriangle size={14} className="inline mr-1"/> No anomalies in this view.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <AdviserDrawer
        open={adviser.open}
        onClose={()=>setAdviser({open:false, anomalyId: null})}
        anomalyId={adviser.anomalyId}
      />
    </div>
  );
}
